import { useMemo } from 'react'
import { OrderProgressEntity } from 'orders/domain/entities/order.entity'
import { AppTable } from 'components/molecules/AppTable/AppTable'
import { RuleIndexBadge } from 'components/atoms/RuleIndexBadge/RuleIndexBadge'
import { ContainerlessRuleAdapter } from 'orders/infrastructure/adapters/ContainerlessRuleAdapter'

interface Props {
    progress: OrderProgressEntity
    columns: string[]
}

const cellClass = 'px-6 py-4 border-t border-[#E2E8F0] text-sm text-[#1E293B]'

/** Rule table for orders without containerization: columns by mode, no containers. */
const ContainerlessRuleTable = ({ progress, columns }: Props) => {
    const rows = useMemo(() => ContainerlessRuleAdapter.buildRows(progress), [progress])
    const hasChuteColumn = columns.includes('Chute')
    const dataHead = columns.map((title) => ({
        id: title,
        title,
        className: 'px-6 py-3 text-left text-xs font-medium text-[#64748B]',
    }))

    return (
        <AppTable dataHead={dataHead}>
            <tbody>
                {rows.map((row) => (
                    <tr key={row.key}>
                        {hasChuteColumn && (
                            <td className={cellClass}>{row.chuteNumber ?? '—'}</td>
                        )}
                        <td className={cellClass}>
                            <span className="inline-flex items-center gap-2">
                                {row.ruleName}
                                {row.sequence != null && <RuleIndexBadge index={row.sequence} />}
                            </span>
                        </td>
                        <td className="px-6 py-4 border-t border-[#E2E8F0] text-base font-semibold text-[#1E293B]">{row.packages}</td>
                    </tr>
                ))}
                {rows.length === 0 && (
                    <tr>
                        <td colSpan={columns.length} className="px-6 py-6 text-center text-sm text-[#94A3B8] border-t border-[#E2E8F0]">
                            Sin reglas para mostrar
                        </td>
                    </tr>
                )}
            </tbody>
        </AppTable>
    )
}

export default ContainerlessRuleTable
